import {connectToStores} from 'epic-alt-utils';
import Error404 from 'epic-fortnite-react/components/error/Error404';
import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router';

import FriendInvite from '../../components/friendInvite/FriendInvite';
import {FriendInviteStore, HeaderStore, AppConfigStore} from '../../stores';

@connectToStores
class FriendInviteView extends React.Component {
  static propTypes = {
    friendInviteStore: PropTypes.object,
    appConfigStore: PropTypes.object,
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
  };

  static getStores() {
    return [FriendInviteStore, HeaderStore, AppConfigStore];
  }

  static getPropsFromStores() {
    return {
      friendInviteStore: FriendInviteStore.getState(),
      appConfigStore: AppConfigStore.getState(),
      mobile: HeaderStore.getState().mobile(),
      tablet: HeaderStore.getState().tablet(),
    };
  }

  render() {
    const {friendInviteStore, appConfigStore, tablet, mobile} = this.props;
    if (!appConfigStore.friendLinkEnabled) {
      return <Error404 />;
    }
    const {data} = friendInviteStore.friendInvite;
    const backgroundImage =
      tablet || mobile ? data.background.tabletImage : data.background.desktopImage;
    const containerStyle = {background: `url(${backgroundImage}) no-repeat center`};
    return (
      <div className="friend-invite-view container-fluid" style={containerStyle}>
        <FriendInvite data={data} />
      </div>
    );
  }
}

export default withRouter(FriendInviteView);
